import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiFormHelperTextStyles = {
    styleOverrides: {
        root: {
            '&.Mui-error': {
                color: Palette.red.red800,
                background: Palette.red.red50,
                margin: '4px 0 0',
                padding: '7px 12px',
                borderRadius: '12px',
                fontSize: '11px',
                '&.MuiFormHelperText-sizeSmall': {
                    fontSize: '11px',
                    marginTop: '2px',
                },
            },
        },
    },
};
